import { type ContactAddress } from "@repo/api";
import { cs } from "@repo/ui";
import { type FC } from "react";
import { Trigger } from "../../Link";
import { useDrawer } from "../context";
import ChangeAddressDrawerForm from "./form";

const ChangeAddressDrawer: FC<ContactAddress & {
	disabled: boolean;
	setFormWasSend: (val: boolean) => void;
	refetch: boolean;
}> = ({
	contractNumber,
	title,
	disabled,
	setFormWasSend,
	refetch,
}) => {
		const { showDrawer, setDrawerContent } = useDrawer();

		return (
			<Trigger
				sx={{ whiteSpace: "nowrap" }}
				disabled={disabled}
				onClick={() => {
					showDrawer();
					setDrawerContent(
						<ChangeAddressDrawerForm
							setFormWasSend={setFormWasSend}
							refetch={refetch}
							title={title}
							contractNumber={contractNumber}
						/>
					);
				}}
			>
				{cs.changeAddress.changeContactAddress}
			</Trigger>
		);
	};

export default ChangeAddressDrawer;
